/**
* @file AllDocNavigator
* @author Ice(chenzhouji@baidu.com)
*/
import React, {FunctionComponent, ReactDOM, useState, useEffect} from 'react';
import _ from 'lodash';
import axios from 'axios';
import {SITE_HEADER_HEIGHT, headerHeightMap} from '@/constants';

const createItemDom = (items: any) => _.map(items, ({name, link}) => {
    return (
        <li className="item" key={link}>
            <a href={link} title={name}>{name}</a>
        </li>
    );
});

const createItemGroupDom = (categories: any) => _.map(categories, ({category, products}) => {
    return (
        <li className="item-group" key={category}>
            <div className="item-group__name">{category}</div>
            <ul className="item-group__items">
                {createItemDom(products)}
            </ul>
        </li>
    );
});

const createLineGroupDom = (groups: any) => _.map(groups, (group, index) => {
    return (
        <li className="line-group" key={index + 1}>
            <ul>
                {createItemGroupDom(group)}
            </ul>
        </li>
    );
});

const getNavItems = (categories: any = []) => {
    const totalCount = categories.reduce((total: number, category: any) => total + category.products.length, 0);
    const evenNum = totalCount / 4;
    const groups = [[], [], [], []];

    for (let i = 0, j = 0; i < categories.length;) {
        const groupLen = groups[j].reduce((len, item: any) => len + item.products.length, 0);
        if (groupLen < evenNum) {
            groups[j].push(categories[i]);
            j === 3 ? (j = 0) : j++;
            i++;
        }
        else {
            j === 3 ? (j = 0) : j++;
        }
    }

    return groups;
};

const AllDocNavigator: FunctionComponent<any> = ({api, template = 'default'}) => {
    if (!api) {
        return null;
    }

    const [categories, setCategories] = useState([]);
    const [height, setHeight] = useState(600);

    useEffect(() => {
        const height = window.innerHeight - _.get(headerHeightMap, template, SITE_HEADER_HEIGHT);
        setHeight(height);

        axios.get(api)
            .then(res => {
                setCategories(_.get(res, 'data', []));
            })
            .catch(err => {
                setCategories([]);
            })
    }, [setCategories, setHeight]);

    const width = 4 * 225 + 24 * 2;
    return (
        <div className="humberger">
            <img src="https://bce.bdstatic.com/portal/img/doc/intl/humberger@2x_7a4d3366.png" />
            <div
                className="product-nagivator"
                style={{
                    height,
                    width,
                    boxSizing: 'border-box'
                }}
            >
                <ul>
                    {createLineGroupDom(getNavItems(categories))}
                </ul>
            </div>
        </div>
    );
};

export default AllDocNavigator;
